import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { validateEnvironment, EnvironmentValidationError } from './utils/envValidation'

// Validate environment variables before starting the app
try {
  validateEnvironment();
} catch (error) {
  if (error instanceof EnvironmentValidationError) {
    // Display error in the DOM instead of just console
    document.getElementById('root')!.innerHTML = `
      <div style="font-family: monospace; padding: 40px; max-width: 900px; margin: 0 auto;">
        <h1 style="color: #dc2626; margin-bottom: 20px;">⚠️ Configuration Error</h1>
        <pre style="background: #1f2937; color: #f3f4f6; padding: 20px; border-radius: 8px; overflow-x: auto; white-space: pre-wrap;">${error.message}</pre>
        <p style="margin-top: 20px; color: #6b7280;">
          <strong>What to do:</strong><br>
          1. Copy .env.example to .env<br>
          2. Fill in all required values<br>
          3. Restart the development server<br>
        </p>
      </div>
    `;
    console.error(error.message);
    throw error; // Stop execution
  }
  throw error;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
